// components/BuscadorClienteFactura/OpcionCliente.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import { FACTURACION_PROPIA } from './constants';

const OpcionCliente = ({ option, props }) => {
  // Si es facturación propia
  if (option.id === FACTURACION_PROPIA.id) {
    return (
      <Box component="li" {...props} sx={{ py: 1.5, borderBottom: '1px solid #eee' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <PersonIcon color="primary" />
          <Box>
            <Typography variant="subtitle2" fontWeight="600">
              {FACTURACION_PROPIA.razon_social}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Usar datos del cliente actual
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  // Si es un cliente normal
  return (
    <Box component="li" {...props} sx={{ py: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: 'primary.main' }} />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="subtitle2" fontWeight="600" noWrap>
            {option.razon_social} - {option.direccion_fiscal}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
            {option.cuit && (
              <>
                <Typography variant="caption" color="text.secondary">
                  CUIT: {option.cuit}
                </Typography>
                <Box sx={{ width: 3, height: 3, borderRadius: '50%', backgroundColor: 'grey.400' }} />
              </>
            )}
            {option.sisven_id && (
              <>
                <Typography variant="caption" color="text.secondary">
                  SISVEN: {option.sisven_id}
                </Typography>
                <Box sx={{ width: 3, height: 3, borderRadius: '50%', backgroundColor: 'grey.400' }} />
              </>
            )}
            <Typography variant="caption" color="text.primary" fontWeight="500">
              {option.localidad || 'Sin localidad'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OpcionCliente;